<template>
    <div class="bg-black h-screen">
        <div class="fixed top-0 left-0 w-full text-center z-50">
            <div class="flex justify-center items-center px-3 py-4 bg-white">
                <div>
                    <a v-bind:href="goback">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="#000000" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs">
                            <path d="M15 18l-6-6 6-6"/>
                        </svg>
                    </a>
                </div>
                <div class="flex-grow" >{{ name }}</div>
                <div style="width: 24px;"></div>
            </div>
            <div class="px-3 py-4 text-white" style="background: rgba(0,0,0,.5);">
                <div v-if="validationActive">
                    QRコードをかざしてください
                </div>

                <div v-if="validationPending">
                    解析中
                </div>

                <div v-if="validationSuccess">
                    読み込み完了
                </div>

                <div v-if="validationFailure">
                    不正なQRコードです
                </div>
            </div>
        </div>

        <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit" v-bind:class="{ mirror:mirror }"></qrcode-stream>

        <div class="fixed bottom-0 right-0 w-full">
            <div class="px-3 py-4 text-white text-center" style="background: rgba(0,0,0,.5);">
                {{ error || '&emsp;' }}
            </div>
            <div class="px-3 py-3 w-full bg-white text-right">
                <button @click="switchCamera"
                        class="opacity-75 hover:opacity-100 bg-gray-300 hover:bg-gray-400 font-bold py-2 px-4 rounded inline-flex items-center">
                    <svg class="inline-block mr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                         viewBox="0 0 24 24" fill="none"
                         stroke="#000000" stroke-width="3" stroke-linecap="square" stroke-linejoin="arcs">
                        <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/>
                    </svg>
                    カメラ切り替え
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {QrcodeStream} from 'vue-qrcode-reader'

    export default {
        components: {QrcodeStream},
        props: {
            goback: {
                type: String,
                default: '/',
            },
            action: {
                type: Number,
                default: 0,
                required: true,
            },
            name: {
                type: String,
                default: null,
                required: true,
            },
        },
        data() {
            return {
                isValid: undefined,
                error: '',
                camera: localStorage.camera || 'auto',
                result: null,
                lat: null,
                lng: null,
                mirror: false,
            }
        },
        computed: {
            validationActive() {
                return this.isValid === undefined && this.camera !== 'off';
            },

            validationPending() {
                return this.isValid === undefined && this.camera === 'off';
            },

            validationSuccess() {
                return this.isValid === true;
            },

            validationFailure() {
                return this.isValid === false;
            },
        },
        methods: {
            onInit(promise) {
                this.getCurrentPosition();

                promise
                    .catch(this.logError)
                    .then(this.resetValidationState);

                this.setMirror();
            },

            switchCamera() {
                switch (this.camera) {
                    case 'front':
                        this.camera = 'rear';
                        break;
                    case 'rear':
                        this.camera = 'front';
                        break;
                    default:
                        this.camera = 'front';
                }

                localStorage.camera = this.camera;
                this.setMirror();
            },

            logError(error) {
                console.error(error);

                let message = '原因不明のエラーが発生しました';

                if (error.name === 'NotAllowedError') {
                    message = "カメラへのアクセス権限がありません"
                } else if (error.name === 'NotFoundError') {
                    message = "カメラが見つかりませんでした"
                } else if (error.name === 'NotSupportedError') {
                    message = "安全な接続ではありません"
                } else if (error.name === 'NotReadableError') {
                    message = "カメラが使用可能な状態にありません"
                } else if (error.name === 'OverconstrainedError') {
                    message = "設置されたカメラは適切ではありません"
                } else if (error.name === 'StreamApiNotSupportedError') {
                    message = "お使いのブラウザはサポートされておりません"
                }

                this.$swal({
                    type: 'error',
                    title: 'ERROR',
                    text: message,
                }).then(() => {
                    window.location = (this.goback);
                });
            },

            resetValidationState() {
                this.isValid = undefined;
            },

            async onDecode(content) {
                this.result = content;
                this.turnCameraOff();

                // pretend it's taking really long
                await this.timeout(3000);
                this.isValid = this.isUrl(content);

                if (this.isValid) {
                    this.postData(content);
                }

                // some more delay, so users have time to read the message
                await this.timeout(2000);

                this.turnCameraOn();
            },

            postData(content) {
                let data = {
                    'm': this.action,
                    '_token': document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
                };

                if(this.lat && this.lng){
                   data.lat = this.lat;
                   data.lng = this.lng;
                }

                this.post(content, data);
            },

            turnCameraOn() {
                this.camera = localStorage.camera || 'auto';
            },

            turnCameraOff() {
                this.camera = 'off';
            },

            setMirror() {
                this.mirror = this.camera === 'front';
            },

            isUrl(str) {
                return str.startsWith('http')
            },

            timeout(ms) {
                return new Promise(resolve => {
                    window.setTimeout(resolve, ms);
                })
            },

            getUrlVars() {
                let vars = {};
                let param = location.search.substring(1).split('&');
                for (let i = 0; i < param.length; i++) {
                    let keySearch = param[i].search(/=/);
                    let key = '';
                    if (keySearch !== -1) key = param[i].slice(0, keySearch);
                    let val = param[i].slice(param[i].indexOf('=', 0) + 1);
                    if (key !== '') vars[key] = decodeURI(val);
                }
                return vars;
            },

            post(content, data) {
                let form = document.createElement("form");
                form.setAttribute("action", content);
                form.setAttribute("method", "POST");
                form.style.display = "none";
                document.body.appendChild(form);
                for (let paramName in data) {
                    let input = document.createElement('input');
                    input.setAttribute('type', 'hidden');
                    input.setAttribute('name', paramName);
                    input.setAttribute('value', data[paramName]);
                    form.appendChild(input);
                }
                form.submit();
            },

            getCurrentPosition() {
                navigator.geolocation.getCurrentPosition(
                    // [第1引数] 取得に成功した場合の関数
                    (position) => {
                        // 取得したデータの整理
                        let data = position.coords;

                        /*
                        // データの整理
                        let lat = data.latitude;
                        let lng = data.longitude;
                        let alt = data.altitude;
                        let accLatlng = data.accuracy;
                        let accAlt = data.altitudeAccuracy;
                        let heading = data.heading; //0=北,90=東,180=南,270=西
                        let speed = data.speed;
                        */

                        this.lat = data.latitude;
                        this.lng = data.longitude;
                    },

                    // [第2引数] 取得に失敗した場合の関数
                    (error) => {
                        // エラーコード(error.code)の番号
                        // 0:UNKNOWN_ERROR				原因不明のエラー
                        // 1:PERMISSION_DENIED			利用者が位置情報の取得を許可しなかった
                        // 2:POSITION_UNAVAILABLE		電波状況などで位置情報が取得できなかった
                        // 3:TIMEOUT					位置情報の取得に時間がかかり過ぎた…

                        // エラー番号に対応したメッセージ
                        let errorInfo = [
                            "位置情報の取得時に原因不明のエラーが発生しました",
                            "位置情報の取得が許可されませんでした",
                            "電波状況などで位置情報が取得できませんでした",
                            "位置情報の取得に時間がかかり過ぎてタイムアウトしました"
                        ];

                        let errorMessage = errorInfo[error.code];

                        // this.$swal({
                        //     type: 'error',
                        //     title: 'ERROR',
                        //     text: errorMessage,
                        // });

                        // this.error = '位置情報が取得できませんでした';
                    },

                    // [第3引数] オプション
                    {
                        "enableHighAccuracy": false,
                        "timeout": 8000,
                        "maximumAge": 2000,
                    }
                );
            },
        }
    }
</script>


<style scoped>
    .mirror {
        transform: scaleX(-1);
    }
</style>
